// Import necessary modules
import React from "react";

const Terms = () => {
  return (
    <div className="bg-gray-100 min-h-screen py-8 px-4">
      <div className="max-w-7xl mx-auto  shadow-md rounded-lg p-6">
        <h1 className="text-3xl font-bold text-center text-gray-800 mb-6">
          Terms and Conditions
        </h1>

        <p className="text-gray-700 mb-4">Welcome to ayanshtechnology!</p>

        <p className="text-gray-700 mb-4">
          These terms and conditions outline the rules and regulations for the
          use of Ayanshtech Solutions's Website, located at
          <a
            href="https://ayanshtechnology.com/"
            className="text-blue-600 hover:underline"
          >
            {" "}
            https://ayanshtechnology.com/
          </a>
          .
        </p>

        <p className="text-gray-700 mb-4">
          By accessing this website we assume you accept these terms and
          conditions. Do not continue to use ayanshtechnology if you do not
          agree to take all of the terms and conditions stated on this page.
        </p>

        <h2 className="text-xl font-semibold text-gray-800 mb-4">Cookies</h2>
        <p className="text-gray-700 mb-4">
          We employ the use of cookies. By accessing ayanshtechnology, you
          agreed to use cookies in agreement with the Ayanshtech Solutions's
          Privacy Policy.
        </p>
        <p className=" text-gray-700 mb-4">
          Most interactive websites use cookies to let us retrieve the user’s
          details for each visit. Cookies are used by our website to enable the
          functionality of certain areas to make it easier for people visiting
          our website. Some of our affiliate/advertising partners may also use
          cookies
        </p>

        <h2 className="text-xl font-semibold text-gray-800 mb-4">License</h2>
        <p className="text-gray-700 mb-4">
          Unless otherwise stated, Ayanstech solutions and/or its licensors own
          the intellectual property rights for all material on ayanshtechnology.
          All intellectual property rights are reserved.
        </p>
        <p className="text-gray-700 mb-2">You must not : </p>

        <ul className="list-disc list-inside text-gray-700 mb-4">
          <li>Republish material from ayanshtechnology</li>
          <li>Sell, rent or sub-license material from ayanshtechnology</li>
          <li>Reproduce, duplicate or copy material from ayanshtechnology</li>
          <li>Redistribute content from ayanshtechnology</li>
        </ul>

        <p className="text-gray-700 mb-2">
          Parts of this website offer an opportunity for users to post and
          exchange opinions and information in certain areas of the website.
          Ayanstech solutions does not filter, edit, publish or review Comments
          prior to their presence on the website. Comments do not reflect the
          views and opinions of Ayanstech solutions,its agents and/or
          affiliates. Comments reflect the views and opinions of the person who
          post their views and opinions. To the extent permitted by applicable
          laws, Ayanstech solutions shall not be liable for the Comments or for
          any liability, damages or expenses caused and/or suffered as a result
          of any use of and/or posting of and/or appearance of the Comments on
          this website.{" "}
        </p>
        <p className="text-gray-700 mb-2">
          Ayanstech solutions reserves the right to monitor all Comments and to
          remove any Comments which can be considered inappropriate, offensive
          or causes breach of these Terms and Conditions.{" "}
        </p>
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Hyperlinking to our Content
        </h2>
        <p className="text-gray-700 mb-4">
          The following organizations may link to our Website without prior
          written approval:
        </p>

        <ul className="list-disc list-inside text-gray-700 mb-4">
          <li>Government agencies</li>
          <li>Search engines</li>
          <li>News organizations</li>
          <li>Online directory distributors</li>
          <li>System-wide Accredited Businesses</li>
        </ul>

        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Content Liability
        </h2>
        <p className="text-gray-700 mb-4">
          We shall not be hold responsible for any content that appears on your
          Website. You agree to protect and defend us against all claims that is
          rising on your Website.
        </p>

        <h2 className="text-xl font-semibold text-gray-800 mb-4">Disclaimer</h2>
        <p className="text-gray-700 mb-4">
          To the maximum extent permitted by applicable law, we exclude all
          representations, warranties and conditions relating to our website and
          the use of this website.
        </p>

        <p className="text-gray-700 mb-4">
          As long as the website and the information and services on the website
          are provided free of charge, we will not be liable for any loss or
          damage of any nature.
        </p>
      </div>
    </div>
  );
};

export default Terms;
